import { render, staticRenderFns } from "./AgendaToolbar.vue?vue&type=template&id=58132286&scoped=true"
import script from "./AgendaToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgendaToolbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AgendaToolbar.vue?vue&type=style&index=0&id=58132286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58132286",
  null
  
)

export default component.exports